import { UpcomingQuizzes } from "./-components/upcoming-quizzes"
import { PersonalInfoCard } from "./-components/personal-info-card"
import { StatsOverviewCard } from "./-components/stats-overview-card"
import { WelcomeBanner } from "./-components/welcome-banner"
import { createFileRoute } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { api } from "@convex/_generated/api"
import { z } from "zod"

const appSearchSchema = z.object({
  timeFilter: z.enum(["upcoming", "past", "all"]).optional(),
  quizTypeFilter: z.enum(["daily", "specialist"]).optional(),
})

export const Route = createFileRoute("/(app)/app/")({
  component: RouteComponent,
  validateSearch: (search) => appSearchSchema.parse(search),
})

function RouteComponent() {
  const userStats = useQuery(api.users.handlers.getUserStats)
  // Show banner when query has loaded AND user has no active subscription
  const hasNoSubscription =
    userStats !== undefined && !userStats?.activeSubscription

  return (
    <main className="flex flex-col gap-6 p-4 md:p-6">
      {/* Welcome banner for users without active subscription */}
      {hasNoSubscription && <WelcomeBanner />}

      {/* Top Row: Personal Info + Stats Overview */}
      <div className="grid gap-6 md:grid-cols-2">
        <PersonalInfoCard />
        <StatsOverviewCard />
      </div>

      {/* Upcoming and Past Quizzes */}
      <UpcomingQuizzes />
    </main>
  )
}
